import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const youtube = defineConnector({
  identifier: "youtube",
  name: "YouTube",
  tagLine: "Video sharing and streaming platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () =>
    "https://(?:www\\.googleapis\\.com/youtube/.*|youtube\\.googleapis\\.com/.*)",
  auth: (app) => queryAuth([{ name: "key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get a YouTube Data API key",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Google Cloud Console](https://console.cloud.google.com/apis/credentials), enable the **YouTube Data API v3**, and create an API key or OAuth 2.0 credentials.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText:
            "An API key for public data access, or an OAuth 2.0 access token for private data.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://www.googleapis.com/youtube/v3/i18nLanguages?part=snippet",
  },
});
